import Vue from 'vue'
import Vuex from 'vuex'
import pageModule from './modules/page/index'
import userModule from './modules/user/user'
import flagsModule from './modules/flags/flags'
import searchModule from './modules/search/search'
import projectsModule from './modules/projects/projects'
import modalsModule from './modules/modals/modals'
import messageModule from './modules/message/message'
import dealbookModule from './modules/dealbook/dealbook'
import profilePageModule from './modules/profile-page/profile-page'
import settingsModule from './modules/settings/settings'
import proposalFiltersModule from './modules/proposal-filters/proposal-filters'
import legacyModule from './modules/legacy/legacy'
import tokensModule from 'asokoinsight-tokens/src/vuex/tokens'

Vue.use(Vuex)

export default new Vuex.Store({
  state: legacyModule.state,
  getters: {
    ...legacyModule.getters,
  },
  actions: legacyModule.actions,
  mutations: legacyModule.mutations,
  modules: {
    page: pageModule,
    user: userModule,
    flags: flagsModule,
    modals: modalsModule,
    message: messageModule,
    search: searchModule,
    projects: projectsModule,
    dealbook: dealbookModule,
    entity: profilePageModule,
    settings: settingsModule,
    tokens: tokensModule,
    proposal: proposalFiltersModule,
  },
})
